export default __webpack_public_path__ + "static/media/p3.5bd6089b.png";